class Favorites {
  constructor() {
    this.storageKey = 'komono-favorites';
    this.container = document.querySelector('[data-favorites-container]');
    this.productsContainer = document.querySelector('[data-favorites-products]');
    this.loadingElement = document.querySelector('[data-favorites-loading]');
    this.emptyStateElement = document.querySelector('[data-favorites-empty-state]');
    
    // Initialize favorites functionality across the site
    this.setupGlobalEvents();
    
    // If we're on the favorites page, load the favorites
    if (this.container) {
      this.loadFavorites();
    }
  }
  
  setupGlobalEvents() {
    // Update all favorite buttons on page load
    this.updateFavoriteButtonsStatus();
  }
  
  getProductHandleFromUrl(url) {
    const match = url.match(/\/products\/([a-zA-Z0-9-_]+)/);
    return match ? match[1] : null;
  }
  
  // toggleFavorite(productHandle, buttonElement) {
  //   const favorites = this.getFavorites();
  //   console.log('Current favorites:', favorites);
  //   const isFavorite = favorites.includes(productHandle);
    
  //   if (isFavorite) {
  //     // Remove from favorites
  //     const index = favorites.indexOf(productHandle);
  //     favorites.splice(index, 1);
  //     console.log('Removed from favorites:', productHandle);
  //     buttonElement.classList.remove('is-favorite');
  //   } else {
  //     // Add to favorites
  //     favorites.push(productHandle);
  //     console.log('added to favorites:', productHandle);
  //     buttonElement.classList.add('is-favorite');
  //   }
    
  //   this.saveFavorites(favorites);
    
  //   // If we're on the favorites page, refresh the display
  //   // if (this.container) {
  //   //   this.loadFavorites();
  //   // }
  // }

  // toggleFavorite(productHandle, buttonElement) {
  //   console.log('Toggling favorite for:', productHandle);
  //   if (!productHandle) return false;

  //   const favorites = this.getFavorites();
  //   const isFavorite = favorites.includes(productHandle);
    
  //   if (isFavorite) {
  //     // Remove from favorites
  //     const index = favorites.indexOf(productHandle);
  //     favorites.splice(index, 1);
      
  //     // Update button if provided
  //     if (buttonElement) {
  //       buttonElement.classList.remove('is-favorite');
  //       // If button has aria-label, update it
  //       if (buttonElement.hasAttribute('aria-label')) {
  //         buttonElement.setAttribute('aria-label', 'Add to favorites');
  //       }
  //     }
  //   } else {
  //     // Add to favorites
  //     favorites.push(productHandle);
      
  //     // Update button if provided
  //     if (buttonElement) {
  //       buttonElement.classList.add('is-favorite');
  //       // If button has aria-label, update it
  //       if (buttonElement.hasAttribute('aria-label')) {
  //         buttonElement.setAttribute('aria-label', 'Remove from favorites');
  //       }
  //     }
  //   }
    
  //   saveFavorites(favorites);


  //   // if on a product page, update all product favorite buttons to be sure
  //   if (window.location.pathname.includes('/products/')) {
  //     updateFavoriteButtonsStatus();

  //     // also update the product page button if it exists
  //     const productPageButton = document.querySelector('.product__favorite-button');
  //     const isFavorite = favorites.includes(productHandle);
  //     if (productPageButton && productPageButton.getAttribute('data-product-handle') !== productHandle) {
  //       return !isFavorite; // exit if not matching
  //     } else {
  //       console.log('productPageButton handle matches current product');
  //       if (!isFavorite) {
  //         productPageButton.classList.remove('is-favorite');
  //         if (productPageButton.hasAttribute('aria-label')) {
  //           productPageButton.setAttribute('aria-label', 'Add to favorites');
  //         }
  //       } else {
  //         productPageButton.classList.add('is-favorite');
  //         if (productPageButton.hasAttribute('aria-label')) {
  //           productPageButton.setAttribute('aria-label', 'Remove from favorites');
  //         }
  //       }
  //     }
  //   }
    
  //   // Return new state
  //   return !isFavorite;
  // }
  
  getFavorites() {
    const favoritesJson = localStorage.getItem(this.storageKey);
    return favoritesJson ? JSON.parse(favoritesJson) : [];
  }
  
  saveFavorites(favorites) {
    localStorage.setItem(this.storageKey, JSON.stringify(favorites));
  }
  
  updateFavoriteButtonsStatus() {
    const favorites = this.getFavorites();
    if (favorites.length === 0) return;
    
    const productCards = document.querySelectorAll('[data-product-card]');
    
    productCards.forEach(card => {
      const link = card.querySelector('a.card-product__link, a.card-product__media');
      if (!link) return;
      
      const productUrl = link.getAttribute('href');
      const productHandle = this.getProductHandleFromUrl(productUrl);
      
      if (productHandle && favorites.includes(productHandle)) {
        const favoriteButton = card.querySelector('.card-product__favorite');
        if (favoriteButton) {
          favoriteButton.classList.add('is-favorite');
        }
      }
    });
  }
  
  async loadFavorites() {
    if (!this.container) return;
        
    const favorites = this.getFavorites();
    
    if (favorites.length === 0) {
      // Show empty state
      this.container.classList.remove('is-loading');
      setTimeout(() => {
        this.container.classList.add('is-empty');
      }, 400);
      return;
    }
    
    try {
      // Fetch all products in parallel
      const productPromises = favorites.map(handle => 
        fetch(`${window.Shopify.routes.root}products/${handle}.js`)
          .then(response => response.json())
          .catch(error => {
            console.error(`Failed to fetch product ${handle}:`, error);
            return null;
          })
      );
      
      const products = await Promise.all(productPromises);
      const validProducts = products.filter(p => p !== null);
      
      if (validProducts.length > 0) {
        // Clear existing content
        this.productsContainer.innerHTML = '';
        
        for (const product of validProducts) {
          // Create product card and add to container
          const productCard = this.createProductCard(product);
          this.productsContainer.appendChild(productCard);
        }
        
        // Initialize Swiper for product galleries if needed
        if (window.Swiper) {
          const swipers = this.productsContainer.querySelectorAll('.card-product__gallery.swiper');
          swipers.forEach(el => {
            new Swiper(el, {
              pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true
              }
            });
          });
        }
        
        // Initialize quick add buttons
        if (window.initQuickAddButtons) {
          window.initQuickAddButtons(this.productsContainer);
        }
        // Show products
        this.container.classList.remove('is-loading');
        setTimeout(() => {
          this.container.classList.add('is-filled');
        }, 400);
      } else {
        // No valid products found
        this.container.classList.remove('is-loading');
        setTimeout(() => {
          this.container.classList.add('is-empty');
        }, 400);
      }
    } catch (error) {
      // this.loadingElement.style.display = 'none';
      // this.emptyStateElement.style.display = 'block';
      // this.productsContainer.style.display = 'none';
      this.container.classList.remove('is-loading');
      setTimeout(() => {
        this.container.classList.add('is-empty');
      }, 400);
    }
  }
  
  createProductCard(product) {
    // Create main card element
    const cardElement = document.createElement('div');
    cardElement.className = `card-product${product.type === "Opticals" ? " card-product--opticals" : ""}${product.type === "Watch" ? " card-product--watch" : ""}${product.type === "Jewelry" ? " card-product--jewelry" : ""}${product.tags.includes("coming-soon") ? " card-product--coming-soon" : ""}`;
    cardElement.setAttribute('data-product-card', '');
    
    // Product media
    const mediaLink = document.createElement('a');
    mediaLink.href = `/products/${product.handle}`;
    mediaLink.className = 'card-product__media';
    
    if (product.images && product.images.length > 0) {
      // Create gallery
      const gallery = document.createElement('div');
      gallery.className = 'card-product__gallery swiper';
      
      // First image section
      const firstImageContainer = document.createElement('div');
      firstImageContainer.className = 'card-product__gallery--first';
      
      // Check if shot_on_face metafield exists
      const shotOnFace = product.metafields && product.metafields.custom && 
                        product.metafields.custom.shot_on_face;
      const showShotOnFace = shotOnFace ? true : false;
      
      if (showShotOnFace) {
        // Determine if it's an image or video
        const shotOnFaceUrl = shotOnFace;
        const isVideo = shotOnFaceUrl && 
                      (shotOnFaceUrl.includes('.mp4') || 
                      shotOnFaceUrl.includes('.mov') || 
                      shotOnFaceUrl.includes('.webm'));
        
        if (isVideo) {
          // Create video element
          const video = document.createElement('video');
          video.className = 'card-product__gallery--first-video';
          video.autoplay = true;
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          
          const source = document.createElement('source');
          source.src = shotOnFaceUrl;
          
          // Set type based on extension
          if (shotOnFaceUrl.includes('.mp4')) {
            source.type = 'video/mp4';
          } else if (shotOnFaceUrl.includes('.webm')) {
            source.type = 'video/webm';
          } else if (shotOnFaceUrl.includes('.mov')) {
            source.type = 'video/quicktime';
          }
          
          video.appendChild(source);
          video.appendChild(document.createTextNode('Your browser does not support the video tag.'));
          firstImageContainer.appendChild(video);
        } else {
          // Create image element for shot_on_face
          const img = document.createElement('img');
          img.src = shotOnFaceUrl;
          img.alt = product.title;
          img.className = 'card-product__gallery--first-image';
          img.loading = 'lazy';
          firstImageContainer.appendChild(img);
        }
      } else {
        // Use featured image
        const featuredImg = document.createElement('img');
        featuredImg.src = product.featured_image || 
                          (product.images[0] && product.images[0].src) || 
                          (product.media && product.media[0] && product.media[0].src);
        featuredImg.alt = product.title;
        featuredImg.className = 'card-product__gallery--first-image first-image--product';
        featuredImg.loading = 'lazy';
        firstImageContainer.appendChild(featuredImg);
      }
      
      gallery.appendChild(firstImageContainer);
      
      // Create swiper wrapper for additional images
      const swiperWrapper = document.createElement('div');
      swiperWrapper.className = 'swiper-wrapper';
      
      // Skip first image if not using shot_on_face
      let mediaOffset = showShotOnFace ? 0 : 1;
      // Set special class for second image if needed
      let mediaSecondContain = showShotOnFace ? true : false;
      
      const images = product.images || [];
      
      for (let i = mediaOffset; i < images.length; i++) {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        
        const image = images[i];
        
        if (image && typeof image === 'object' && image.media_type === 'video') {
          const video = document.createElement('video');
          video.className = 'card-product__video';
          video.autoplay = true;
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          video.appendChild(document.createTextNode('Your browser does not support the video tag.'));
          slide.appendChild(video);
        } else {
          // Handle image
          const img = document.createElement('img');
          img.src = (image && image.src) || image;
          img.alt = product.title;
          
          // Apply special class for second image if needed
          if (i === 1 && mediaSecondContain) {
            img.className = 'card-product__image card-product__image-second-contain';
          } else {
            img.className = 'card-product__image';
          }
          
          img.loading = 'lazy';
          slide.appendChild(img);
        }
        
        swiperWrapper.appendChild(slide);
      }
      
      gallery.appendChild(swiperWrapper);
      
      // Add pagination if multiple images
      if (images.length > 1) {
        const pagination = document.createElement('div');
        pagination.className = 'swiper-pagination';
        gallery.appendChild(pagination);
      }
      
      mediaLink.appendChild(gallery);
    } else {
      // No media placeholder
      const noMedia = document.createElement('div');
      noMedia.className = 'card-product__no-media';
      noMedia.innerHTML = `<svg class="placeholder-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.5-1.3-2.8-2.9-2.8zm.1 95.3H203.1v-92.5h121.6v92.5z"/><path d="M210.4 299.5H239c1.6 0 2.8-1.3 2.8-2.8v-59.9c0-1.6-1.3-2.8-2.8-2.8h-28.6c-1.6 0-2.8 1.3-2.8 2.8v59.9c0 1.5 1.3 2.8 2.8 2.8zm2.8-59.9h23v54.3h-23v-54.3zM309.1 236.8h-28.6c-1.6 0-2.8 1.3-2.8 2.8v28.6c0 1.6 1.3 2.8 2.8 2.8h28.6c1.6 0 2.8-1.3 2.8-2.8v-28.6c.1-1.6-1.2-2.8-2.8-2.8zm-2.7 28.6h-23v-23h23v23z"/></svg>`;
      mediaLink.appendChild(noMedia);
    }

    const badgeElement = this.createProductBadge(product);
    if (badgeElement) {
      mediaLink.appendChild(badgeElement);
    }
    
    // Favorite button with active state
    const favorite = document.createElement('button');
    favorite.setAttribute('onclick', `toggleFavorite('${product.handle}', this, '${product.title}')`);
    favorite.setAttribute('tabindex', '-1');
    favorite.className = 'card-product__favorite is-favorite';
    favorite.innerHTML = `
      <svg class="icon icon-heart" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
        <path d="M8 4.7905L7.29375 4.08425L6.53438 3.32488C5.92813 2.7155 5.10313 2.37488 4.24375 2.37488C2.45313 2.37488 1 3.828 1 5.61863C1 6.478 1.34063 7.303 1.95 7.91238L2.70625 8.66863L8 13.9624L13.2937 8.66863L14.05 7.91238C14.6594 7.303 15 6.478 15 5.61863C15 3.828 13.5469 2.37488 11.7563 2.37488C10.8969 2.37488 10.0719 2.7155 9.4625 3.32488L8.70625 4.08113L8 4.7905ZM8.70625 14.6686L8 15.3749L7.29375 14.6686L2 9.37488L1.24375 8.61863C0.446875 7.82175 0 6.74363 0 5.61863C0 3.27488 1.9 1.37488 4.24375 1.37488C5.36875 1.37488 6.44688 1.82175 7.24375 2.61863L7.29375 2.66863L8 3.37488L8.70625 2.66863L8.75625 2.61863C9.55313 1.82175 10.6313 1.37488 11.7563 1.37488C14.1 1.37488 16 3.27488 16 5.61863C16 6.74363 15.5531 7.82175 14.7563 8.61863L14 9.37488L8.70625 14.6686Z" fill="inherit"></path>
        <path class="icon-heart-fill-layer" d="M8.70625 14.6686L8 15.3749L7.29375 14.6686L2 9.37488L1.24375 8.61863C0.446875 7.82175 0 6.74363 0 5.61863C0 3.27488 1.9 1.37488 4.24375 1.37488C5.36875 1.37488 6.44688 1.82175 7.24375 2.61863L7.29375 2.66863L8 3.37488L8.70625 2.66863L8.75625 2.61863C9.55313 1.82175 10.6313 1.37488 11.7563 1.37488C14.1 1.37488 16 3.27488 16 5.61863C16 6.74363 15.5531 7.82175 14.7563 8.61863L14 9.37488L8.70625 14.6686Z" fill="inherit"></path>
      </svg>
    `;
    
    // Product info section
    const info = document.createElement('div');
    info.className = 'card-product__info';
    
    // Product title
    const title = document.createElement('a');
    title.href = `/products/${product.handle}`;
    title.className = 'card-product__title card-product__link';
    title.textContent = product.title;
    
    // Product price
    const priceContainer = document.createElement('div');
    priceContainer.className = 'card-product__price';
    
    const showPriceOnComingSoon = window.showComingSoonPrices || false;
    // console.log('showPriceOnComingSoon', showPriceOnComingSoon, window.showComingSoonPrices);
    const isComingSoon = product.tags?.includes('coming-soon');

    // Only add price if not opticals or coming soon with setting enabled
    if (isComingSoon) {
      if(showPriceOnComingSoon) {
        const priceInner = document.createElement('div');
        priceInner.className = `card-product__price-inner price${product.compare_at_price > product.price ? ' price--on-sale' : ''}`;
        
        let priceHTML = '';
        
        // Add original price if on sale
        if (product.compare_at_price > product.price) {
          priceHTML += `<span class="price__original" aria-hidden="true">${formatMoney(product.compare_at_price)}</span>`;
          priceHTML += `<span class="visually-hidden">Regular price</span>`;
        }
        
        // Current price
        priceHTML += `<span class="price__current">${formatMoney(product.price)}</span>`;
        
        // Sale price label and savings if on sale
        if (product.compare_at_price > product.price) {
          priceHTML += `<span class="visually-hidden">Sale price</span>`;
          priceHTML += `<span class="price__savings">Save ${formatMoney(product.compare_at_price - product.price)}</span>`;
        }
        
        priceInner.innerHTML = priceHTML;
        priceContainer.appendChild(priceInner);
      }
    } else if (product.type !== "Opticals") {
      const priceInner = document.createElement('div');
      priceInner.className = `card-product__price-inner price${product.compare_at_price > product.price ? ' price--on-sale' : ''}`;
      
      let priceHTML = '';
      
      // Add original price if on sale
      if (product.compare_at_price > product.price) {
        priceHTML += `<span class="price__original" aria-hidden="true">${formatMoney(product.compare_at_price)}</span>`;
        priceHTML += `<span class="visually-hidden">Regular price</span>`;
      }
      
      // Current price
      priceHTML += `<span class="price__current">${formatMoney(product.price)}</span>`;
      
      // Sale price label and savings if on sale
      if (product.compare_at_price > product.price) {
        priceHTML += `<span class="visually-hidden">Sale price</span>`;
        priceHTML += `<span class="price__savings">Save ${formatMoney(product.compare_at_price - product.price)}</span>`;
      }
      
      priceInner.innerHTML = priceHTML;
      priceContainer.appendChild(priceInner);
    }
    
    // Add elements to info container
    info.appendChild(title);
    info.appendChild(priceContainer);
    
    // Quick add button only for single-variant products
    if (product.available && !isComingSoon && product.type !== "Opticals" && product.variants?.length === 1) {
      const quickAdd = document.createElement('div');
      quickAdd.setAttribute('role', 'button');
      quickAdd.className = 'card-product__quick-add';
      quickAdd.setAttribute('data-quick-add', '');
      quickAdd.setAttribute('data-product-id', product.id);
      quickAdd.setAttribute('data-variant-id', product.variants[0].id);
      quickAdd.innerHTML = `
        <svg class="icon icon-plus" xmlns="http://www.w3.org/2000/svg" width="16" height="19" viewBox="0 0 16 19" fill="none">
          <path class="icon-plus__horizontal" d="M7.42746 8.55261H1.14174H0.570312V9.69296H1.14174H7.42746H8.57031H14.856H15.4275V8.55261H14.856H8.57031H7.42746Z" fill="inherit"></path>
          <path class="icon-plus__vertical" d="M8.57031 8.55136L8.57031 2.26564L8.57031 1.69421L7.42996 1.69421L7.42996 2.26564L7.42996 8.55136L7.42996 9.69421L7.42996 15.9799L7.42996 16.5514L8.57031 16.5514L8.57031 15.9799L8.57031 9.69421L8.57031 8.55136Z" fill="inherit"></path>
        </svg>
      `;
      info.appendChild(quickAdd);
    }
    
    // Add colors indicator if applicable
    if (product.options.some(option => option.name.toLowerCase().includes('color'))) {
      const colorsText = document.createElement('p');
      colorsText.className = 'card-product__colors';
      colorsText.textContent = `+${product.variants.length} colors`;
      info.appendChild(colorsText);
    }
    
    // Add all sections to card
    cardElement.appendChild(mediaLink);
    cardElement.appendChild(favorite);
    cardElement.appendChild(info);
    
    return cardElement;
  }

  // Add this new method to the Favorites class
  createProductBadge(product) {
    let badgeToShow = "";
    
    // Get settings from window.theme
    const showPriceOnOpticals = window.theme?.show_price_on_opticals || false;
    const seasonalBadgeTag = window.theme?.product_tag_seasonal_current || '';
    const seasonalBadgeText = window.theme?.product_badge_seasonal_current || '';
    const seasonalBadgeIcon = window.theme?.product_badge_seasonal_icon || '';
    const nextBadgeIcon = window.theme?.product_badge_next || '';

    const isComingSoon = product.tags?.includes('coming-soon');
    
    // Determine which badge to show
    if (showPriceOnOpticals) {
      if (isComingSoon) {
        badgeToShow = "Coming Soon";
      } else if (!product.available) {
        badgeToShow = "Notify";
      } else if (product.metafields?.custom?.badge) {
        badgeToShow = "Custom";
      } else if (product.type === "Opticals") {
        badgeToShow = "Optical";
      } else if (product.tags?.includes(seasonalBadgeTag) && seasonalBadgeText) {
        badgeToShow = "Odyssey";
      } else if (product.tags?.includes("filter-NEXT")) {
        badgeToShow = "Next";
      }
    } else {
      if (isComingSoon) {
        badgeToShow = "Coming Soon";
      } else if (product.type === "Opticals") {
        badgeToShow = "Optical";
      } else if (!product.available) {
        badgeToShow = "Notify";
      } else if (product.metafields?.custom?.badge) {
        badgeToShow = "Custom";
      } else if (product.tags?.includes(seasonalBadgeTag) && seasonalBadgeText) {
        badgeToShow = "Odyssey";
      } else if (product.tags?.includes("filter-NEXT")) {
        badgeToShow = "Next";
      }
    }

    
    if (!badgeToShow) return null;
    
    // Create badge element
    const badgeElement = document.createElement('div');
    badgeElement.className = `product__badge${badgeToShow === "Next" ? " product__badge--next" : ""}${badgeToShow === "Notify" ? " product__badge--notify" : ""}${badgeToShow === "Coming Soon" ? " product__badge--notify" : ""}${badgeToShow === "LowStock" ? " product__badge--low-stock" : ""}`;
    
    let badgeHTML = '';
    
    switch (badgeToShow) {
      case "Notify":
        badgeHTML = '<span class="badge badge--notify">Notify me</span>';
        break;
      case "Optical":
        badgeHTML = '<span class="badge badge--optical">Optical</span>';
        break;
      case "Odyssey":
        if (seasonalBadgeIcon) {
          badgeHTML = `<span class="badge__icon"><img src="${seasonalBadgeIcon}" class="badge__image" loading="eager" alt=""></span>`;
        }
        badgeHTML += `<span class="badge badge--odyssey">${seasonalBadgeText || 'Odyssey'}</span>`;
        break;
      case "Next":
        if (nextBadgeIcon) {
          badgeHTML = `<span class="badge__icon badge__icon--next"><img src="${nextBadgeIcon}" class="badge__image" loading="eager" alt=""></span>`;
        } else {
          badgeHTML = '<span class="badge badge--next">KOMONO NEXT</span>';
        }
        break;
      case "Custom":
        badgeHTML = `<span class="badge badge--custom">${product.metafields.custom.badge}</span>`;
        break;
      default:
        badgeHTML = `<span class="badge">${badgeToShow}</span>`;
    }
    
    badgeElement.innerHTML = badgeHTML;
    return badgeElement;
  }
  
  // Helper to format money
  formatMoney(cents) {
    return '€' + (parseFloat(cents) / 100).toFixed(2);
  }
}

// Initialize on document load
document.addEventListener('DOMContentLoaded', () => {
  new Favorites();
});